import { ElementRef, forwardRef, useImperativeHandle, useRef } from 'react';
import styled from 'styled-components';

import T from '../../../translate';
import { usePrivacyPolicy } from '../../hooks';
import { useGlobalStore } from '../../state/globalStore';
import { Checkbox, StyledError } from '../elements';

interface AgreeCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error: boolean;
}
export const AgreeCheckbox = forwardRef<{ shakeError: () => void }, AgreeCheckboxProps>(
  ({ checked, onChange, error }: AgreeCheckboxProps, ref) => {
    const styledErrorRef = useRef<ElementRef<typeof StyledError>>(null);
    const {
      nonEditableTextStyle: { privacyPolicy: privacyPolicyStyle },
    } = useGlobalStore((store) => store.leadCapture);

    const { copy } = usePrivacyPolicy();

    useImperativeHandle(ref, () => ({
      shakeError() {
        styledErrorRef.current?.shakeError();
      },
    }));

    return (
      <CheckboxWrapper>
        <Checkbox
          error={error}
          checked={checked}
          onChange={(e) => {
            onChange(e.target.checked);
          }}
          label={<AgreePolicy color={privacyPolicyStyle.color}>{copy}</AgreePolicy>}
        />
        {error && <StyledError topOffset={28} ref={styledErrorRef} error={T.OptingInIsRequired} />}
      </CheckboxWrapper>
    );
  },
);

const CheckboxWrapper = styled.div`
  position: relative;
`;

const AgreePolicy = styled.div<{ color: string }>`
  font-size: 11px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: ${({ color }) => color};
`;
